import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { collection, query, orderBy, onSnapshot, doc, updateDoc, deleteDoc, runTransaction, where, getDocs, limit } from "firebase/firestore"; 
import { db } from "../firebase";
import { matchesSearch } from '../utils/searchText';
import { confirmTeslimatDelivery } from "../utils/teslimatOnayService";
import { 
  Modal, Box, Typography, Button, TextField, Select, MenuItem, Alert, Chip, 
  Dialog, DialogTitle, DialogContent, DialogActions, Grid, Card, CardContent, Divider, Avatar,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, InputAdornment, IconButton, Stack, CircularProgress,
  useMediaQuery, useTheme
} from "@mui/material";
import PersonIcon from '@mui/icons-material/Person';
import InfoIcon from '@mui/icons-material/Info';
import PaymentIcon from '@mui/icons-material/Payment';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SaveIcon from '@mui/icons-material/Save';
import CloseIcon from '@mui/icons-material/Close';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import DescriptionIcon from '@mui/icons-material/Description';
import SearchIcon from '@mui/icons-material/Search';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import StoreIcon from '@mui/icons-material/Store';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import BusinessIcon from '@mui/icons-material/Business';
import CategoryIcon from '@mui/icons-material/Category';
import ScaleIcon from '@mui/icons-material/Scale';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';

/** İşlem detayı: modal kağıt genişliği (px). Masaüstünde üç sütun CSS Grid ile `minmax(0,1fr)` paylaşılır (taşma yok). */
const ISLEM_DETAY_MODAL_GENISLIK_PX = 1440;

/** Mobil: tam genişlik sütun. Masaüstü: grid hücresi %100 (genişlik grid tarafından verilir). */
const islemDetayKutuDisSx = {
  width: '100%',
  minWidth: 0,
  maxWidth: '100%',
  display: 'flex',
  boxSizing: 'border-box'
};

// Dar ekranda gizlenen sutunlar (NO, TARIH, SAAT, ADET, GRAM, TUR, TUTAR, DURUM).
// MUI'nin md esigi 900px oldugu icin iPad dikeyde (768px) bu sutunlar kayboluyor ve
// tablo 2 sutuna dusuyordu. Dokunmatik tabletlerde geri aciliyor; tablo yatay
// kaydirilabilir kapsayicida duruyor. Masaustu kosulu (md) aynen korunuyor.
const tiHideOnMobile = {
  display: { xs: 'none', md: 'table-cell' },
  '@media (min-width: 700px) and (max-width: 1649px), (min-width: 700px) and (any-pointer: coarse)': { display: 'table-cell' }
};

function TumIslemler() {
  const theme = useTheme();
  const isDesktopWide = useMediaQuery(theme.breakpoints.up('md'));
  // Dokunmatik tabletler de "genis" sayilir: tam tablo, 10 sutunluk bos durum ve
  // genis sayfalama gosterilir. Masaustu davranisi degismez.
  // Dar masaustu penceresi (<1100px) de tablet duzenini kullanir
  const isTouchTablet = useMediaQuery(
    '(min-width: 700px) and (max-width: 1649px), (min-width: 700px) and (any-pointer: coarse)'
  );
  const isMdUp = isDesktopWide || isTouchTablet;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const subeFromUrl = queryParams.get("sube")?.trim();
  const [islemler, setIslemler] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [searchTerm, setSearchTerm] = useState("");
  /** Tek gün filtresi (tarih aralığı yok) */
  const [filterDate, setFilterDate] = useState("");
  
  const [openModal, setOpenModal] = useState(false);
  const [selectedIslem, setSelectedIslem] = useState(null);
  const [selectedGroupItems, setSelectedGroupItems] = useState([]);
  const [hoveredGroupKey, setHoveredGroupKey] = useState(null);
  const [editForm, setEditForm] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isEditing, setIsEditing] = useState(false);

  /** Masaüstü (md+): 8 satır / sayfa; mobil: 6 satır / sayfa */
  const itemsPerPage = isMdUp ? 8 : 6;

  const kategoriler = ["Sarrafiye", "Gram Altın", "Takı Ürün", "Hurda", "Döviz", "Genel"];
  const islemTurleri = ["Alış", "Satış", "Giriş", "Çıkış", "İade", "Değişim"];
  const urunlerListesi = {
    Sarrafiye: ["Eski Ziynet Çeyrek", "Yeni Ziynet Çeyrek", "Eski Ziynet Yarım", "Yeni Ziynet Yarım", "Eski Ziynet Tam", "Yeni Ziynet Tam", "Eski Ziynet 2.5’lu Gremse", "Yeni Ziynet 2.5’lu Gremse", "Eski Ziynet Beşli", "Yeni Ziynet Beşli", "Cumhuriyet Ata Çeyrek", "Cumhuriyet Ata Yarım", "Cumhuriyet Ata", "Cumhuriyet Ata 2.5’lu", "Cumhuriyet Ata Beşli", "Reşat", "Reşat 2.5’lu", "Reşat Beşli"],
    "Gram Altın": ["1 Gram 22 Ayar", "0.50 Gram 22 Ayar", "0.25 Gram 22 Ayar", "1 Gram 24 Ayar", "0.50 Gram 24 Ayar", "0.25 Gram 24 Ayar", "2.50 Gram 24 Ayar", "5 Gram 24 Ayar", "1 Gram 24 Ayar", "20 Gram 24 Ayar", "50 Gram 24 Ayar", "100 Gram 24 Ayar"],
    "Takı Ürün": ["22 Ayar Bilezik", "14 Ayar Bilezik", "8 Ayar Bilezik", "22 Ayar Takı", "21 Ayar Takı", "18 Ayar Takı", "14 Ayar Takı", "8 Ayar Takı"],
    Hurda: ["24 Ayar Hurda", "22 Ayar Bilezik Hurda", "22 Ayar Hurda", "21 Ayar Hurda", "18 Ayar Hurda", "14 Ayar Hurda", "8 Ayar Hurda"],
    Döviz: ["TL - Türk Lirası", "USD - Amerikan Doları", "EUR - Euro", "GBP - İngiliz Sterlini", "CHF - İsviçre Frangı", "AUD - Avustralya Doları", "CAD - Kanada Doları", "SAR - Suudi Arabistan Riyali", "AED - Birleşik Arap Emirlikleri Dirhemi", "QAR - Katar Riyali", "MAD - Fas Dirhemi", "JOD - Ürdün Dinarı", "KWD - Kuveyt Dinarı", "CNY - Çin Yuanı", "RUB - Rus Rublesi", "BGN - Bulgar Levası"],
    Genel: ["Gümüş"],
  };

  const getSubeAdi = (kod) => {
      switch(kod) {
          case 'sefakoy_merkez': return 'Sefaköy Merkez Mağaza';
          case 'sefakoy_sube': return 'Sefaköy Şube Mağaza';
          case 'kavakli_sube': return 'Kavaklı Şube Mağaza';
          default: return 'Bilinmeyen Şube';
      }
  };

  useEffect(() => {
    if (!subeFromUrl) {
      setError("Şube bilgisi eksik.");
      return;
    }

    const q = query(collection(db, "subeler", subeFromUrl, "islemler"), orderBy("timestamp", "desc"));
    const unsubscribe = onSnapshot(q, (snapshot) => {
        if (snapshot.empty) {
          setError("Kayıtlı işlem bulunamadı.");
          setIslemler([]);
          return;
        }
        const rawData = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
          subNo: doc.data().subNo || 0,
        }));
        const allIslemler = rawData.slice();
        allIslemler.sort((a, b) => {
          const timeA = a.timestamp?.seconds ? a.timestamp.seconds * 1000 : (a.timestamp || 0);
          const timeB = b.timestamp?.seconds ? b.timestamp.seconds * 1000 : (b.timestamp || 0);
          if (timeB !== timeA) return timeB - timeA;
          if (a.groupId && b.groupId && a.groupId === b.groupId) {
            return (a.subNo || 0) - (b.subNo || 0);
          }
          return 0;
        });
        setIslemler(allIslemler);
        setError("");
      },
      (err) => { setError(`Veri çekme hatası: ${err.message}`); }
    );
    return () => unsubscribe();
  }, [subeFromUrl]);

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return { tarih: "Belirtilmemiş", saat: "Belirtilmemiş" };
    let date;
    if (typeof timestamp === "string") {
      try { date = new Date(timestamp); } catch (e) { return { tarih: "Geçersiz", saat: "Geçersiz" }; }
    } else if (timestamp && typeof timestamp === "object" && "seconds" in timestamp) {
      date = new Date(timestamp.seconds * 1000 + (timestamp.nanoseconds || 0) / 1000000);
    } else { return { tarih: "Belirtilmemiş", saat: "Belirtilmemiş" }; }
    if (isNaN(date.getTime())) return { tarih: "Geçersiz", saat: "Geçersiz" };
    return {
      tarih: date.toLocaleDateString("tr-TR", { year: "numeric", month: "2-digit", day: "2-digit" }),
      saat: date.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" }),
      tamTarih: date.toLocaleString('tr-TR')
    };
  };

  const formatMusteriFirma = (islem) => {
    if (islem.musteri && islem.musteri.isim) return `${islem.musteri.isim} ${islem.musteri.soyisim || ""}`.trim();
    else if (islem.firma && islem.firma.firmaIsmi) return islem.firma.firmaIsmi;
    return "Tanımsız Müşteri";
  };

  const formatCurrency = (val) => {
    return val ? parseFloat(val).toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + ' TL' : '0.00 TL';
  };

  const formatAdetGram = (islem) => {
    const isTL = islem.kategori === "Döviz" && islem.urun === "TL - Türk Lirası";
    const isDecimalAllowed = islem.kategori === "Hurda" || islem.kategori === "Takı Ürün";
    const gram = islem.gram ? (isDecimalAllowed ? parseFloat(islem.gram).toFixed(2) : parseInt(islem.gram)) : "0";
    const adet = islem.adet ? parseInt(islem.adet) : "0";
    const nakit = parseFloat(islem.nakit) || 0;

    if (islem.kategori === "Sarrafiye" || islem.kategori === "Gram Altın" || (islem.kategori === "Döviz" && !isTL)) {
      return { adet: adet, gram: "0" };
    } else if (islem.kategori === "Takı Ürün") {
      return { adet: adet, gram: gram };
    } else if (islem.kategori === "Hurda") {
      return { adet: "0", gram: gram };
    } else if (isTL) {
      return { adet: nakit.toFixed(2), gram: "0" };
    } else if (islem.kategori === "Genel") {
      return { adet: adet, gram: gram };
    }
    return { adet: "0", gram: "0" };
  };

  const buildEditForm = (islem) => ({
    islemNo: islem.islemNo || "",
    musteriIsim: islem.musteri ? `${islem.musteri.isim || ""} ${islem.musteri.soyisim || ""}`.trim() : "",
    firmaIsmi: islem.firma ? islem.firma.firmaIsmi || "" : "",
    kategori: islem.kategori || "",
    urun: islem.urun || "",
    islemTuru: islem.islemTuru || "",
    gram: islem.gram || "",
    adet: islem.adet || "",
    hasFiyati: islem.hasFiyati || "",
    urunBilgisi: islem.urunBilgisi || "",
    barkod: islem.barkod || "",
    islemAciklamasi: islem.islemAciklamasi || "",
    bakiye: islem.bakiye || "",
    nakit: islem.nakit || "",
    havaleEft: islem.havaleEft || "",
    krediKarti: islem.krediKarti || "",
    teslimatDurumu: islem.teslimatDurumu || "Teslim Edildi",
    planlananTeslimTarihi: islem.planlananTeslimTarihi || "",
  });

  const getDisplayIslemNo = (islemNo, groupCount = 1) => {
    const rawNo = (islemNo || "-").toString();
    if (groupCount > 1) {
      // Çoklu kayıtlarda alt sıra eki (/1, /2...) görünmesin.
      return rawNo.replace(/\/\d+$/, '');
    }
    return rawNo;
  };

  const handleRowClick = (islem) => {
    let groupItems = [islem];
    if (islem.groupId) {
      groupItems = islemler
        .filter(i => i.groupId === islem.groupId)
        .sort((a, b) => (a.subNo || 0) - (b.subNo || 0));
    }

    setSelectedGroupItems(groupItems);
    setSelectedIslem(islem);
    setEditForm(buildEditForm(islem));
    setIsEditing(false);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setTimeout(() => { 
        setSelectedIslem(null);
        setSelectedGroupItems([]);
        setEditForm(null);
        setIsEditing(false);
        setSuccess("");
        setError("");
        setLoading(false);
    }, 200);
  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;
    setEditForm((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "kategori" ? { urun: "" } : {}),
    }));
  };

  const handleTeslimatTamamla = async () => {
    if (!window.confirm("Bu ürünü teslim etmek ve stoğu ŞİMDİ düşmek istiyor musunuz?")) return;

    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const result = await confirmTeslimatDelivery(db, subeFromUrl, selectedIslem.id);

      if (result.success) {
        setSuccess(result.message);
        const updatedIslem = {
          ...selectedIslem,
          teslimatDurumu: "Teslim Edildi",
          teslimatStokDusuldu: true,
        };
        setSelectedIslem(updatedIslem);
        setIslemler((prev) => prev.map((i) => (i.id === selectedIslem.id ? updatedIslem : i)));
        setEditForm((prev) => ({ ...prev, teslimatDurumu: "Teslim Edildi" }));
      } else {
        setError(result.message);
        if (result.alreadyDone) {
          const updatedIslem = {
            ...selectedIslem,
            teslimatDurumu: "Teslim Edildi",
            teslimatStokDusuldu: true,
          };
          setSelectedIslem(updatedIslem);
          setIslemler((prev) => prev.map((i) => (i.id === selectedIslem.id ? updatedIslem : i)));
          setEditForm((prev) => ({ ...prev, teslimatDurumu: "Teslim Edildi" }));
        }
      }
    } catch (err) {
      console.error("Teslimat Hatası:", err);
      setError("İşlem başarısız: " + err.message);
    } finally {
      setLoading(false);
    }
  };

  // --- KRİTİK DÜZELTME: MÜŞTERİ ID KORUMA ---
  const handleEditSubmit = async () => {
    setError("");
    setSuccess("");
    try {
      // Müşteri verisi oluşturulurken ID kontrolü yap
      // Eğer isim hiç değişmediyse, seçili işlemin müşteri ID'sini koru
      // Eğer isim değiştiyse, yeni isimle kaydet (ID null olabilir, bu durumda manuel müşteri olur)
      
      let musteriToSave = null;
      if (editForm.musteriIsim) {
          const girilenIsim = editForm.musteriIsim.trim();
          const eskiIsim = selectedIslem.musteri 
              ? `${selectedIslem.musteri.isim} ${selectedIslem.musteri.soyisim || ""}`.trim() 
              : "";

          if (selectedIslem.musteri && selectedIslem.musteri.id && girilenIsim === eskiIsim) {
              // İsim aynı, ID'yi koru (Bakiye takibi için kritik)
              musteriToSave = {
                  id: selectedIslem.musteri.id,
                  isim: selectedIslem.musteri.isim,
                  soyisim: selectedIslem.musteri.soyisim || "",
                  telefon: selectedIslem.musteri.telefon || "" // Varsa telefonu da koru
              };
          } else {
              // İsim değişmiş, sadece isim soyisim olarak kaydet (ID kaybolur, yeni kayıt gibi olur)
              musteriToSave = {
                  isim: girilenIsim.split(" ").slice(0, -1).join(" ") || girilenIsim,
                  soyisim: girilenIsim.split(" ").pop() || "",
              };
          }
      }

      // Firma verisi için de benzer kontrol
      let firmaToSave = null;
      if (editForm.firmaIsmi) {
          const girilenFirma = editForm.firmaIsmi.trim();
          const eskiFirma = selectedIslem.firma ? selectedIslem.firma.firmaIsmi : "";

          if (selectedIslem.firma && selectedIslem.firma.id && girilenFirma === eskiFirma) {
              firmaToSave = {
                  id: selectedIslem.firma.id,
                  firmaIsmi: selectedIslem.firma.firmaIsmi
              };
          } else {
              firmaToSave = { firmaIsmi: girilenFirma };
          }
      }

      const isDecimalAllowed = editForm.kategori === "Hurda" || editForm.kategori === "Takı Ürün";
      const gramValue = isDecimalAllowed ? parseFloat(editForm.gram) || 0 : parseInt(editForm.gram) || 0;
      const adetValue = parseInt(editForm.adet) || 0;
      const toplamTutar =
        (parseFloat(editForm.nakit) || 0) + (parseFloat(editForm.havaleEft) || 0) + (parseFloat(editForm.krediKarti) || 0) + (parseFloat(editForm.bakiye) || 0);

      const islemData = {
        islemNo: editForm.islemNo,
        kategori: editForm.kategori || null,
        urun: editForm.urun || null,
        islemTuru: editForm.islemTuru || null,
        musteri: musteriToSave, // Düzelmiş Müşteri Nesnesi
        firma: firmaToSave,     // Düzelmiş Firma Nesnesi
        barkod: editForm.barkod || null,
        gram: gramValue,
        adet: adetValue,
        urunBilgisi: editForm.urunBilgisi || null,
        islemAciklamasi: editForm.islemAciklamasi || null,
        hasFiyati: parseFloat(editForm.hasFiyati) || 0,
        bakiye: parseFloat(editForm.bakiye) || 0,
        nakit: parseFloat(editForm.nakit) || 0,
        havaleEft: parseFloat(editForm.havaleEft) || 0,
        krediKarti: parseFloat(editForm.krediKarti) || 0,
        toplamTutar: parseFloat(toplamTutar.toFixed(2)),
        teslimatDurumu: editForm.teslimatDurumu || "Teslim Edildi",
        planlananTeslimTarihi: editForm.teslimatDurumu === "Teslimat Bekliyor" ? editForm.planlananTeslimTarihi : null, 
        islemFisi: selectedIslem.islemFisi || null,
        timestamp: selectedIslem.timestamp,
        sube: subeFromUrl,
        isMulti: selectedIslem.isMulti,
        groupId: selectedIslem.groupId || null,
        subNo: selectedIslem.subNo || 0,
      };

      await updateDoc(doc(db, "subeler", subeFromUrl, "islemler", selectedIslem.id), islemData);
      setSuccess("İşlem başarıyla güncellendi.");
      setIslemler((prev) => prev.map((i) => (i.id === selectedIslem.id ? { ...i, ...islemData } : i)));
      setSelectedIslem({ ...selectedIslem, ...islemData });
      setIsEditing(false);
    } catch (err) {
      setError(`İşlem güncellenemedi: ${err.message}`);
    }
  };

  const handleDelete = async () => {
    try {
      const islemTarihi = selectedIslem.timestamp; 
      const gunsonuRef = collection(db, "subeler", subeFromUrl, "gunsonukasa");
      const q = query(gunsonuRef, where("timestamp", ">", islemTarihi), limit(1));
      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        setError("HATA: Bu işlem tarihinden sonra Günsonu Raporu alınmıştır. Geçmişe dönük silme yapılamaz.");
        return; 
      }

      if (window.confirm("Bu işlemi silmek istediğinize emin misiniz?")) {
        await deleteDoc(doc(db, "subeler", subeFromUrl, "islemler", selectedIslem.id));
        setIslemler((prev) => prev.filter((i) => i.id !== selectedIslem.id));
        setSuccess("İşlem başarıyla silindi.");
        handleCloseModal();
      }
    } catch (err) {
      setError(`İşlem silinemedi: ${err.message}`);
    }
  };

  const filteredIslemler = islemler.filter((islem) => {
    const musteriFirma = formatMusteriFirma(islem) || "";
    const islemTarih = islem.timestamp ? new Date(islem.timestamp.seconds ? islem.timestamp.seconds * 1000 : islem.timestamp) : null;
    const matchesSearchTerm = matchesSearch(searchTerm, musteriFirma, islem.urun, islem.islemTuru, islem.islemNo);
    let matchesDate = true;
    if (filterDate) {
      if (!islemTarih || Number.isNaN(islemTarih.getTime())) matchesDate = false;
      else {
        const y = islemTarih.getFullYear();
        const m = String(islemTarih.getMonth() + 1).padStart(2, '0');
        const d = String(islemTarih.getDate()).padStart(2, '0');
        matchesDate = `${y}-${m}-${d}` === filterDate;
      }
    }
    return matchesSearchTerm && matchesDate;
  });

  const groupedIslemler = React.useMemo(() => {
    const groups = [];
    const seen = new Set();

    filteredIslemler.forEach((item) => {
      if (item.groupId) {
        if (seen.has(item.groupId)) return;
        seen.add(item.groupId);
        const groupItems = filteredIslemler
          .filter((i) => i.groupId === item.groupId)
          .sort((a, b) => (a.subNo || 0) - (b.subNo || 0));

        groups.push({
          groupKey: item.groupId,
          firstItem: groupItems[0],
          items: groupItems
        });
      } else {
        groups.push({
          groupKey: item.id,
          firstItem: item,
          items: [item]
        });
      }
    });

    return groups;
  }, [filteredIslemler]);

  const pagedGroups = React.useMemo(() => {
    const pages = [];
    let currentPageGroups = [];
    let usedRows = 0;

    groupedIslemler.forEach((group) => {
      const groupRows = group.items.length;
      const exceedsPage = usedRows + groupRows > itemsPerPage;

      if (exceedsPage && currentPageGroups.length > 0) {
        pages.push(currentPageGroups);
        currentPageGroups = [];
        usedRows = 0;
      }

      currentPageGroups.push(group);
      usedRows += groupRows;
    });

    if (currentPageGroups.length > 0) {
      pages.push(currentPageGroups);
    }

    return pages;
  }, [groupedIslemler, itemsPerPage]);

  const pageCount = pagedGroups.length;
  const currentItems = pagedGroups[currentPage] || [];

  const maxButtons = isMdUp ? 10 : 5;
  const halfButtons = Math.floor(maxButtons / 2);
  let startPage = Math.max(0, currentPage - halfButtons);
  let endPage = Math.min(pageCount - 1, startPage + maxButtons - 1);
  if (endPage - startPage < maxButtons - 1) { startPage = Math.max(0, endPage - maxButtons + 1); }

  useEffect(() => {
    if (pageCount === 0 && currentPage !== 0) {
      setCurrentPage(0);
      return;
    }
    if (pageCount > 0 && currentPage > pageCount - 1) {
      setCurrentPage(pageCount - 1);
    }
  }, [pageCount, currentPage]);

  const DetailRow = ({ label, value, icon, color, dense }) => (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        mb: dense ? 0 : { xs: 1, md: 1.4 },
        borderBottom: dense ? 'none' : '1px solid #f0f0f0',
        pb: dense ? 0 : { xs: 0.5, md: 0.85 },
        minWidth: 0
      }}
    >
      <Typography variant="caption" color="textSecondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.5, fontSize: { xs: '0.6rem', md: '0.74rem' }, fontWeight:'bold', letterSpacing:{ xs: '0.3px', md: '0.38px' }, textTransform:'uppercase' }}>
        {icon && React.cloneElement(icon, { sx: { fontSize: { xs: 13, md: 16 } } })} {label}
      </Typography>
      <Typography variant="h6" fontWeight="600" sx={{ mt: { xs: 0.22, md: 0.45 }, wordBreak: 'break-word', color: color || '#1e293b', fontSize: dense ? { xs: '0.78rem', md: '0.98rem' } : { xs: '0.88rem', md: '1.08rem' } }}>
        {value || "-"}
      </Typography>
    </Box>
  );

  return (
    <Box
      sx={{
        p: { xs: 1.25, md: 2 },
        pb: { xs: 2, md: 2 },
        background: 'linear-gradient(180deg, #f5f8fd 0%, #edf2f9 100%)',
        display: 'flex',
        flexDirection: 'column',
        flex: { xs: 1, md: '0 1 auto' },
        minHeight: { xs: 0, md: 'auto' },
        width: '100%',
        boxSizing: 'border-box',
        /* Mobil: sabit yükseklik + hidden taşmayı keser; kaydırma dashboard-content ile olmalı */
        height: { xs: 'auto', md: 'calc(100vh - 255px)' },
        overflow: { xs: 'visible', md: 'hidden' }
      }}
    >
      {/* ... (Filtreler aynı) ... */}
      <Paper elevation={0} sx={{ p: isMdUp ? 2 : 1.25, mb: { xs: 1.25, md: 2 }, borderRadius: 3, border: '1px solid #dde5f0', background: 'linear-gradient(180deg, #ffffff 0%, #f9fbff 100%)', boxShadow: '0 4px 14px rgba(15,23,42,0.05)', flexShrink: 0 }}>
        <Grid className="ti-filter-grid" container spacing={isMdUp ? 2 : 1} alignItems="center">
            <Grid className="ti-filter-title" item xs={12} lg={3} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <ReceiptLongIcon sx={{ color: '#1e3a8a', fontSize: isMdUp ? 30 : 24 }} />
                <Typography variant="h5" fontWeight="700" color="#1e3a8a" noWrap={isMdUp} sx={!isMdUp ? { fontSize: '1.1rem', lineHeight: 1.2 } : undefined}>
                    Tüm İşlemler
                </Typography>
            </Grid>
            <Grid className="ti-filter-search" item xs={isMdUp ? 12 : 6} lg={5}>
                <TextField
                    fullWidth
                    placeholder={isMdUp ? 'İşlem No, Müşteri, Ürün Ara...' : 'Ara...'}
                    value={searchTerm}
                    onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(0); }}
                    size="small"
                    InputProps={{
                        startAdornment: <InputAdornment position="start"><SearchIcon color="action" sx={{ fontSize: isMdUp ? 24 : 18 }} /></InputAdornment>,
                    }}
                    sx={{
                      backgroundColor: 'white',
                      minWidth: 0,
                      ...(isMdUp
                        ? { '& .MuiOutlinedInput-input': { fontSize: '1rem' } }
                        : { '& .MuiOutlinedInput-input': { fontSize: '14px', py: '8px' } })
                    }}
                />
            </Grid>
            <Grid className="ti-filter-date" item xs={isMdUp ? 12 : 6} lg={4}>
                <TextField
                    fullWidth
                    type="date"
                    label="Tarih"
                    value={filterDate}
                    onChange={(e) => { setFilterDate(e.target.value); setCurrentPage(0); }}
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    sx={{
                      backgroundColor: 'white',
                      minWidth: 0,
                      ...(isMdUp
                        ? {
                            '& .MuiInputLabel-root': { fontSize: '1rem' },
                            '& .MuiOutlinedInput-input': { fontSize: '1rem' }
                          }
                        : {
                            '& .MuiInputLabel-root': { fontSize: '0.7rem' },
                            '& .MuiOutlinedInput-input': { fontSize: '12px', py: '6px' }
                          })
                    }}
                />
            </Grid>
        </Grid>
      </Paper>

      {/* TABLO ALANI */}
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          overflow: { xs: 'hidden', md: 'hidden' },
          borderRadius: 3,
          border: '1px solid #dde5f0',
          boxShadow: '0 6px 18px rgba(15,23,42,0.06)',
          display: 'flex',
          flexDirection: 'column',
          flex: { xs: '0 1 auto', md: 1 },
          minHeight: { xs: 0, md: 0 },
          minWidth: 0
        }}
      >
        <TableContainer
          className="ti-table-wrap"
          sx={{
            overflowY: { xs: 'visible', md: 'hidden' },
            overflowX: { xs: 'hidden', md: 'auto' },
            flex: { xs: '0 1 auto', md: 1 },
            minHeight: { xs: 0, md: 0 },
            WebkitOverflowScrolling: 'touch'
          }}
        >
          <Table className="ti-table" stickyHeader aria-label="sticky table" sx={{ tableLayout: { xs: 'fixed', md: 'auto' }, width: '100%' }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ ...tiHideOnMobile, fontWeight: 800, backgroundColor: '#f9fbff', color: '#0f172a', borderBottom: '2px solid #c88b2c' }}>NO</TableCell>
                <TableCell sx={{ ...tiHideOnMobile, fontWeight: 800, backgroundColor: '#f9fbff', color: '#0f172a', borderBottom: '2px solid #c88b2c' }}>TARİH</TableCell>
                <TableCell sx={{ ...tiHideOnMobile, fontWeight: 800, backgroundColor: '#f9fbff', color: '#0f172a', borderBottom: '2px solid #c88b2c' }}>SAAT</TableCell>
                <TableCell align="left" sx={{ fontWeight: 800, backgroundColor: '#f9fbff', color: '#0f172a', borderBottom: '2px solid #c88b2c', width: { xs: '55%', md: 'auto' }, maxWidth: { xs: '55%', md: 'none' }, fontSize: { xs: '0.54rem', md: '0.875rem' }, py: { xs: '6px', md: '16px' }, px: { xs: '4px', md: '16px' }, lineHeight: 1.2, textAlign: 'left' }}>MÜŞTERİ / FİRMA</TableCell>
                <TableCell align="center" sx={{ ...tiHideOnMobile, fontWeight: 800, backgroundColor: '#f9fbff', color: '#0f172a', borderBottom: '2px solid #c88b2c' }}>ADET</TableCell>
                <TableCell align="center" sx={{ ...tiHideOnMobile, fontWeight: 800, backgroundColor: '#f9fbff', color: '#0f172a', borderBottom: '2px solid #c88b2c' }}>GRAM</TableCell>
                <TableCell sx={{ ...tiHideOnMobile, fontWeight: 800, backgroundColor: '#f9fbff', color: '#0f172a', borderBottom: '2px solid #c88b2c' }}>TÜR</TableCell>
                <TableCell align="right" sx={{ fontWeight: 800, backgroundColor: '#f9fbff', color: '#0f172a', borderBottom: '2px solid #c88b2c', width: { xs: '45%', md: 'auto' }, maxWidth: { xs: '45%', md: 'none' }, fontSize: { xs: '0.65rem', md: '0.875rem' }, py: { xs: '6px', md: '16px' }, px: { xs: '4px', md: '16px' }, lineHeight: 1.2, textAlign: 'right' }}>ÜRÜN</TableCell>
                <TableCell align="right" sx={{ ...tiHideOnMobile, fontWeight: 800, backgroundColor: '#f9fbff', color: '#0f172a', borderBottom: '2px solid #c88b2c' }}>TUTAR</TableCell>
                <TableCell align="center" sx={{ ...tiHideOnMobile, fontWeight: 800, backgroundColor: '#f9fbff', color: '#0f172a', borderBottom: '2px solid #c88b2c' }}>DURUM</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {currentItems.map((group) => {
                const base = group.firstItem;
                const { tarih, saat } = formatTimestamp(base.timestamp);
                const rowSpan = group.items.length;

                const isGroupHovered = hoveredGroupKey === group.groupKey;
                const groupBaseBg = group.items.length > 1 ? '#fffdf7' : undefined;

                return group.items.map((islem, idx) => {
                  const { adet, gram } = formatAdetGram(islem);
                  const teslimat = islem.teslimatDurumu || "Teslim Edildi";

                  return (
                    <TableRow
                      className="ti-data-row"
                      key={islem.id}
                      hover
                      onClick={() => handleRowClick(islem)}
                      onMouseEnter={() => setHoveredGroupKey(group.groupKey)}
                      onMouseLeave={() => setHoveredGroupKey(null)}
                      sx={{
                        cursor: 'pointer',
                        transition: 'background-color 0.2s',
                        backgroundColor: isGroupHovered ? '#e0f2fe' : groupBaseBg,
                        '&:nth-of-type(odd)': { backgroundColor: groupBaseBg || '#f9fafb' },
                        '& td': {
                          py: { xs: '14px', md: 0.55 },
                          px: { xs: '4px', md: undefined },
                          backgroundColor: isGroupHovered ? '#e0f2fe' : groupBaseBg
                        }
                      }}
                    >
                      {idx === 0 && (
                        <>
                          <TableCell 
                            className="ti-cell-no"
                            rowSpan={rowSpan} 
                            sx={{ 
                              ...tiHideOnMobile,
                              fontWeight: 800, 
                              color: '#334155', 
                              verticalAlign: 'middle',
                              fontSize: '1.05rem',
                              textAlign: 'center',
                              letterSpacing: '0.3px',
                              minWidth: 120,
                              borderRight: '1px solid #e5e7eb',
                              backgroundColor: isGroupHovered ? '#e0f2fe' : groupBaseBg
                            }}
                          >
                            {rowSpan > 1 ? `${getDisplayIslemNo(base.islemNo, rowSpan)} (${rowSpan} işlem)` : getDisplayIslemNo(base.islemNo, rowSpan)}
                          </TableCell>
                          <TableCell className="ti-cell-tarih" rowSpan={rowSpan} sx={{ ...tiHideOnMobile, verticalAlign: 'middle', fontWeight: 500, textAlign: 'center', backgroundColor: isGroupHovered ? '#e0f2fe' : groupBaseBg }}>{tarih}</TableCell>
                          <TableCell className="ti-cell-saat" rowSpan={rowSpan} sx={{ ...tiHideOnMobile, verticalAlign: 'middle', fontWeight: 500, textAlign: 'center', backgroundColor: isGroupHovered ? '#e0f2fe' : groupBaseBg }}>{saat}</TableCell>
                          <TableCell
                            className="ti-cell-musteri"
                            rowSpan={rowSpan}
                            align="left"
                            sx={{
                              fontWeight: { xs: 700, md: 600 },
                              verticalAlign: 'middle',
                              textAlign: 'left',
                              backgroundColor: isGroupHovered ? '#e0f2fe' : groupBaseBg,
                              width: { xs: '55%', md: 'auto' },
                              maxWidth: { xs: '55%', md: 'none' },
                              wordBreak: 'break-word',
                              whiteSpace: { xs: 'normal', md: 'normal' },
                              fontSize: { xs: '9px', md: '0.875rem' },
                              lineHeight: { xs: 1.28, md: 1.43 }
                            }}
                          >
                            {formatMusteriFirma(base)}
                          </TableCell>
                        </>
                      )}
                      <TableCell className="ti-cell-adet" align="center" sx={tiHideOnMobile}>{adet}</TableCell>
                      <TableCell className="ti-cell-gram" align="center" sx={tiHideOnMobile}>{gram}</TableCell>
                      <TableCell className="ti-cell-tur" sx={tiHideOnMobile}>
                        <Chip
                          label={islem.islemTuru}
                          size="small"
                          color={islem.islemTuru === 'Satış' ? 'success' : islem.islemTuru === 'Alış' ? 'warning' : 'default'}
                          variant="outlined"
                        />
                      </TableCell>
                      <TableCell
                        className="ti-cell-urun"
                        align="right"
                        sx={{
                          wordBreak: 'break-word',
                          whiteSpace: { xs: 'normal', md: 'normal' },
                          width: { xs: '45%', md: 'auto' },
                          maxWidth: { xs: '45%', md: 'none' },
                          fontSize: { xs: '0.7rem', md: '0.875rem' },
                          lineHeight: { xs: 1.25, md: 1.43 },
                          color: '#334155',
                          textAlign: 'right'
                        }}
                      >
                        {islem.urun || "-"}
                      </TableCell>
                      <TableCell className="ti-cell-tutar" align="right" sx={{ ...tiHideOnMobile, fontWeight: 'bold', color: '#1e3a8a', minWidth: 190 }}>
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', gap: 1.2, lineHeight: 1.2 }}>
                          <Box sx={{ textAlign: 'right', pr: 1, borderRight: '1px solid #d9dee8' }}>
                            <Typography sx={{ fontSize: '0.66rem', color: '#8b5e1b', fontWeight: 700 }}>
                              Toplam:
                            </Typography>
                            <Typography sx={{ fontSize: '0.9rem', color: '#a14b0f', fontWeight: 900 }}>
                              {formatCurrency(islem.toplamTutar)}
                            </Typography>
                          </Box>
                          <Box sx={{ textAlign: 'left', minWidth: 96 }}>
                            <Typography sx={{ fontSize: '0.66rem', fontWeight: 700, color: '#0f8b45' }}>
                              Nakit: {formatCurrency(islem.nakit)}
                            </Typography>
                            <Typography sx={{ fontSize: '0.66rem', fontWeight: 700, color: '#2858b8' }}>
                              H/E: {formatCurrency(islem.havaleEft)}
                            </Typography>
                            <Typography sx={{ fontSize: '0.66rem', fontWeight: 700, color: '#6d28d9' }}>
                              KK: {formatCurrency(islem.krediKarti)}
                            </Typography>
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell className="ti-cell-durum" align="center" sx={tiHideOnMobile}>
                        <Chip
                          label={teslimat === "Teslimat Bekliyor" ? "Bekliyor" : "Teslim"}
                          color={teslimat === "Teslimat Bekliyor" ? "error" : "success"}
                          size="small"
                          sx={{ fontWeight: 'bold', minWidth: 80 }}
                        />
                      </TableCell>
                    </TableRow>
                  );
                });
              })}
              {currentItems.length === 0 && (
                  <TableRow>
                      <TableCell colSpan={isMdUp ? 10 : 2} align="center" sx={{ py: 3 }}>
                          <Typography variant="body1" color="textSecondary">Kayıt bulunamadı.</Typography>
                      </TableCell>
                  </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        
        {/* SAYFALAMA */}
        {isMdUp ? (
        <Stack
            direction="row"
            spacing={1}
            justifyContent="center"
            alignItems="center"
            sx={{
                p: 2,
                borderTop: '1px solid #e0e0e0',
                flexShrink: 0,
                backgroundColor: '#f8fafc',
                borderBottomLeftRadius: 8,
                borderBottomRightRadius: 8
            }}
        >
            <Button
                variant="outlined"
                size="small"
                onClick={() => setCurrentPage(Math.max(0, currentPage - 1))}
                disabled={currentPage === 0}
                startIcon={<NavigateBeforeIcon />}
            >
                Önceki
            </Button>
            {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((page) => (
                <Button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    variant={currentPage === page ? "contained" : "text"}
                    size="small"
                    sx={{ minWidth: 30 }}
                >
                    {page + 1}
                </Button>
            ))}
            <Button
                variant="outlined"
                size="small"
                onClick={() => setCurrentPage(Math.min(pageCount - 1, currentPage + 1))}
                disabled={currentPage === pageCount - 1}
                endIcon={<NavigateNextIcon />}
            >
                Sonraki
            </Button>
        </Stack>
        ) : (
        <Stack
            direction="row"
            alignItems="center"
            spacing={0.5}
            sx={{
                p: 1.25,
                borderTop: '1px solid #e0e0e0',
                flexShrink: 0,
                backgroundColor: '#f8fafc',
                borderBottomLeftRadius: 8,
                borderBottomRightRadius: 8,
                width: '100%',
                minWidth: 0,
                boxSizing: 'border-box'
            }}
        >
            <IconButton
                size="small"
                aria-label="Önceki sayfa"
                onClick={() => setCurrentPage(Math.max(0, currentPage - 1))}
                disabled={currentPage === 0}
                sx={{
                    border: '1px solid #cbd5e1',
                    borderRadius: 1,
                    bgcolor: '#fff',
                    flexShrink: 0,
                    width: 36,
                    height: 36
                }}
            >
                <ChevronLeftIcon fontSize="small" />
            </IconButton>
            <Box
                sx={{
                    flex: 1,
                    minWidth: 0,
                    overflowX: 'auto',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: 0.35,
                    py: 0.25,
                    WebkitOverflowScrolling: 'touch'
                }}
            >
              {Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i).map((page) => (
                <Button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    variant={currentPage === page ? "contained" : "text"}
                    size="small"
                    sx={{
                      minWidth: 28,
                      px: 0.5,
                      fontSize: '0.75rem',
                      fontWeight: 700,
                      flexShrink: 0
                    }}
                >
                    {page + 1}
                </Button>
              ))}
            </Box>
            <IconButton
                size="small"
                aria-label="Sonraki sayfa"
                onClick={() => setCurrentPage(Math.min(pageCount - 1, currentPage + 1))}
                disabled={currentPage === pageCount - 1}
                sx={{
                    border: '1px solid #cbd5e1',
                    borderRadius: 1,
                    bgcolor: '#fff',
                    flexShrink: 0,
                    width: 36,
                    height: 36
                }}
            >
                <ChevronRightIcon fontSize="small" />
            </IconButton>
        </Stack>
        )}
      </Paper>

      {/* DETAY MODALI */}
      <Dialog 
        open={openModal} 
        onClose={handleCloseModal} 
        maxWidth={false} 
        fullWidth={false}
        PaperProps={{ 
            sx: { 
                borderRadius: 2.5, 
                bgcolor: '#f6f8fb',
                width: { xs: 'calc(100vw - 16px)', md: ISLEM_DETAY_MODAL_GENISLIK_PX },
                maxWidth: { xs: 'calc(100vw - 16px)', md: `min(${ISLEM_DETAY_MODAL_GENISLIK_PX}px, calc(100vw - 24px))` },
                boxSizing: 'border-box',
                maxHeight: { xs: '90vh', md: '80vh' },
                overflow: 'hidden'
            } 
        }}
      >
        <DialogTitle sx={{ background: 'linear-gradient(90deg, #132b4a 0%, #1e3657 58%, #b3681f 100%)', color: 'white', display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap: { xs: 'wrap', md: 'nowrap' }, gap: { xs: 1, md: 0 }, py: { xs: 1, md: 1.5 }, px: { xs: 1.5, md: 2.75 } }}>
            <Box sx={{ display:'flex', alignItems:'center', gap: { xs: 1.25, md: 2 }, minWidth: 0 }}>
                <Avatar sx={{ bgcolor: 'rgba(255,255,255,0.12)', width: { xs: 26, md: 36 }, height: { xs: 26, md: 36 }, flexShrink: 0 }}><ReceiptLongIcon sx={{ fontSize: { xs: 15, md: 20 } }} /></Avatar>
                <Typography variant="h6" fontWeight="bold" sx={{letterSpacing:'0.2px', fontSize: { xs: '0.88rem', md: '1.38rem' }, lineHeight: 1.2 }}>İşlem Detayı</Typography>
            </Box>
            <Chip 
                label={`No: ${selectedIslem?.islemNo || "YOK"}`} 
                sx={{ fontWeight: '800', backgroundColor: 'white', color: '#0f172a', border: '1px solid #d4d8de', fontSize: { xs: '0.72rem', md: '0.84rem' }, height: { xs: 26, md: 34 }, flexShrink: 0, maxWidth: { xs: '100%', md: 'none' } }}
            />
        </DialogTitle>
        <DialogContent sx={{ mt: 0, px: { xs: '8px', md: '22px' }, pt: { xs: 1.1, md: 2.85 }, pb: { xs: 1.1, md: 2.25 }, boxSizing: 'border-box', overflowY: 'auto', '& .MuiInputBase-input': { fontSize: { xs: '0.8rem', md: '0.95rem' } }, '& .MuiInputLabel-root': { fontSize: { xs: '0.74rem', md: '0.9rem' } }, '& .MuiSelect-select': { fontSize: { xs: '0.8rem', md: '0.95rem' } }, '& .MuiFormLabel-root': { fontSize: { xs: '0.74rem', md: '0.9rem' } }, '& .MuiMenuItem-root': { fontSize: { xs: '0.76rem', md: '0.88rem' } } }}>
            {selectedIslem && editForm && (
                <Grid container spacing={{ xs: 0.5, md: 1.5 }} alignItems="stretch" sx={{ mt: 0, mx: 0, width: '100%', maxWidth: { xs: '100%', md: `${ISLEM_DETAY_MODAL_GENISLIK_PX - 32}px` } }}> 
                    {!isEditing && selectedGroupItems.length > 1 && (
                      <Grid item xs={12}>
                        <Alert severity="info" sx={{ mb: 0.8, borderRadius: 1.5, py: 0.15, fontSize: { xs: '0.76rem', md: '0.82rem' }, '& .MuiAlert-message': { fontSize: { xs: '0.76rem', md: '0.82rem' } } }}>
                          Bu kayıt aynı seansta girilmiş {selectedGroupItems.length} parçalı çoklu işlemdir.
                        </Alert>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ mb: 1, flexWrap: 'wrap', alignItems: { xs: 'stretch', sm: 'center' } }}>
                          {selectedGroupItems.map((groupItem, index) => (
                            <Button
                              key={groupItem.id}
                              size="small"
                              variant={selectedIslem.id === groupItem.id ? "contained" : "outlined"}
                              onClick={() => {
                                setSelectedIslem(groupItem);
                                setEditForm(buildEditForm(groupItem));
                              }}
                              sx={{
                                borderRadius: 10,
                                textTransform: 'none',
                                fontSize: { xs: '0.76rem', md: '0.82rem' },
                                bgcolor: selectedIslem.id === groupItem.id ? '#1565c0' : undefined
                              }}
                            >
                              {`${index + 1}- ${groupItem.islemNo || '-'}${groupItem.subNo ? `(${groupItem.subNo})` : ''}`}
                            </Button>
                          ))}
                        </Stack>
                      </Grid>
                    )}
                    {(success || error) && (
                      <Grid item xs={12}>
                        {success && <Alert severity="success" sx={{ mb: 2, fontSize: { xs: '0.78rem', md: '0.86rem' }, '& .MuiAlert-message': { fontSize: { xs: '0.78rem', md: '0.86rem' } } }}>{success}</Alert>}
                        {error && <Alert severity="error" sx={{ mb: 2, fontSize: { xs: '0.78rem', md: '0.86rem' }, '& .MuiAlert-message': { fontSize: { xs: '0.78rem', md: '0.86rem' } } }}>{error}</Alert>}
                      </Grid>
                    )}
                    {isEditing ? (
                      <Grid item xs={12}>
                        <Card sx={{ p: { xs: 1.75, md: 3.25 } }}>
                        <Grid container spacing={2}>
                           <Grid item xs={12} sm={6}><TextField label="Müşteri Adı Soyadı" name="musteriIsim" value={editForm.musteriIsim} onChange={handleEditChange} fullWidth /></Grid>
                           <Grid item xs={12} sm={6}><TextField label="Firma İsmi" name="firmaIsmi" value={editForm.firmaIsmi} onChange={handleEditChange} fullWidth /></Grid>
                           <Grid item xs={12} sm={4}>
                             <Select name="kategori" value={editForm.kategori} onChange={handleEditChange} fullWidth displayEmpty>
                               <MenuItem value="">Kategori Seç</MenuItem>
                               {kategoriler.map(k => <MenuItem key={k} value={k}>{k}</MenuItem>)}
                             </Select>
                           </Grid>
                           <Grid item xs={12} sm={4}>
                             <Select name="urun" value={editForm.urun} onChange={handleEditChange} fullWidth displayEmpty disabled={!editForm.kategori}>
                               <MenuItem value="">Ürün Seç</MenuItem>
                               {editForm.kategori && urunlerListesi[editForm.kategori]?.map(u => <MenuItem key={u} value={u}>{u}</MenuItem>)}
                             </Select>
                           </Grid>
                           <Grid item xs={12} sm={4}>
                             <Select name="islemTuru" value={editForm.islemTuru} onChange={handleEditChange} fullWidth displayEmpty>
                               <MenuItem value="">İşlem Türü</MenuItem>
                               {islemTurleri.map(t => <MenuItem key={t} value={t}>{t}</MenuItem>)}
                             </Select>
                           </Grid>
                           <Grid item xs={6} sm={3}><TextField label="Gram" name="gram" type="number" value={editForm.gram} onChange={handleEditChange} fullWidth /></Grid>
                           <Grid item xs={6} sm={3}><TextField label="Adet" name="adet" type="number" value={editForm.adet} onChange={handleEditChange} fullWidth /></Grid>
                           <Grid item xs={12} sm={6}><TextField label="Barkod" name="barkod" value={editForm.barkod} onChange={handleEditChange} fullWidth /></Grid>
                           <Grid item xs={12}><TextField label="Açıklama / Not" name="islemAciklamasi" value={editForm.islemAciklamasi} onChange={handleEditChange} fullWidth multiline rows={2} /></Grid>
                           <Grid item xs={12}><Divider sx={{my: { xs: 1, md: 1.25 }}}><Chip label="Finansal Bilgiler" sx={{ fontSize: { xs: '0.72rem', md: '0.8rem' }, fontWeight: 700 }} /></Divider></Grid>
                           <Grid item xs={6} sm={3}><TextField label="Birim (Has) Fiyat" name="hasFiyati" type="number" value={editForm.hasFiyati} onChange={handleEditChange} fullWidth /></Grid>
                           <Grid item xs={6} sm={3}><TextField label="Nakit" name="nakit" type="number" value={editForm.nakit} onChange={handleEditChange} fullWidth /></Grid>
                           <Grid item xs={6} sm={3}><TextField label="Kredi Kartı" name="krediKarti" type="number" value={editForm.krediKarti} onChange={handleEditChange} fullWidth /></Grid>
                           <Grid item xs={6} sm={3}><TextField label="Havale/EFT" name="havaleEft" type="number" value={editForm.havaleEft} onChange={handleEditChange} fullWidth /></Grid>
                           <Grid item xs={6} sm={3}><TextField label="Bakiye (Borç)" name="bakiye" type="number" value={editForm.bakiye} onChange={handleEditChange} fullWidth /></Grid>
                           <Grid item xs={12}><Divider sx={{my: { xs: 1, md: 1.25 }}}><Chip label="Durum" sx={{ fontSize: { xs: '0.72rem', md: '0.8rem' }, fontWeight: 700 }} /></Divider></Grid>
                           <Grid item xs={12} md={6}>
                             <Select name="teslimatDurumu" value={editForm.teslimatDurumu} onChange={handleEditChange} fullWidth>
                               <MenuItem value="Teslim Edildi">Teslim Edildi</MenuItem>
                               <MenuItem value="Teslimat Bekliyor">Teslimat Bekliyor</MenuItem>
                             </Select>
                           </Grid>
                           {/* YENİ: DÜZENLEME MODUNDA TARİH SEÇME */}
                           {editForm.teslimatDurumu === "Teslimat Bekliyor" && (
                                <Grid item xs={12} md={6}>
                                    <TextField 
                                        label="Planlanan Teslim Tarihi"
                                        type="date"
                                        name="planlananTeslimTarihi"
                                        value={editForm.planlananTeslimTarihi || ""}
                                        onChange={handleEditChange}
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                    />
                                </Grid>
                           )}
                        </Grid>
                        </Card>
                      </Grid>
                    ) : (
                      <Grid item xs={12} sx={{ px: 0 }}>
                        <Box
                          sx={{
                            display: { xs: 'flex', md: 'grid' },
                            flexDirection: { xs: 'column' },
                            gridTemplateColumns: { xs: 'none', md: 'repeat(3, minmax(0, 1fr))' },
                            alignItems: 'stretch',
                            gap: { xs: '8px', md: '20px' },
                            width: '100%',
                            minWidth: 0,
                            maxWidth: { xs: '100%', md: '100%' },
                            alignSelf: 'stretch',
                            boxSizing: 'border-box',
                            mt: { xs: 0, md: 1.25 }
                          }}
                        >
                        <Box sx={islemDetayKutuDisSx}>
                            <Card elevation={2} sx={{ width:'100%', borderRadius: 1.8, border:'1px solid #e2e8f0', display:'flex', flexDirection:'column', overflow:'hidden' }}>
                                <Box sx={{ py: { xs: 0.75, md: 1.2 }, px: { xs: 0.75, md: 1.35 }, display: 'flex', alignItems: 'center', gap: { xs: 0.75, md: 1.1 }, bgcolor: '#e9f4fb', borderBottom: '1px solid #d8e9f8' }}>
                                    <Avatar sx={{ bgcolor: '#1976d2', color:'white', width: { xs: 22, md: 30 }, height: { xs: 22, md: 30 } }}><PersonIcon sx={{ fontSize: { xs: 14, md: 18 } }} /></Avatar>
                                    <Typography variant="h6" fontWeight="bold" color="#1565c0" sx={{ fontSize: { xs: '0.92rem', md: '1.12rem' } }}>Müşteri & özet</Typography>
                                </Box>
                                <CardContent sx={{ flex: 1, py: { xs: 1.15, md: 1.85 }, px: { xs: 0.9, md: 1.35 }, '&:last-child': { pb: { xs: 1.15, md: 1.85 } } }}>
                                    <DetailRow label="Müşteri / Firma Adı" value={formatMusteriFirma(selectedIslem)} icon={<PersonIcon/>} />
                                    <DetailRow label="İşlem Tarihi" value={formatTimestamp(selectedIslem.timestamp).tamTarih} icon={<CalendarTodayIcon/>} />
                                    <DetailRow label="İşlem Türü" value={selectedIslem.islemTuru} icon={<DescriptionIcon/>} color={selectedIslem.islemTuru === 'Satış' ? 'green' : 'orange'} />
                                    <DetailRow label="Şube" value={getSubeAdi(subeFromUrl)} icon={<StoreIcon/>} />
                                </CardContent>
                            </Card>
                        </Box>
                        <Box sx={islemDetayKutuDisSx}>
                            <Card elevation={2} sx={{ width:'100%', borderRadius: 1.8, border:'1px solid #e2e8f0', display:'flex', flexDirection:'column', overflow:'hidden' }}>
                                <Box sx={{ py: { xs: 0.75, md: 1.2 }, px: { xs: 0.75, md: 1.35 }, display: 'flex', alignItems: 'center', gap: { xs: 0.75, md: 1.1 }, bgcolor: '#fff7e8', borderBottom: '1px solid #fde7c1' }}>
                                    <Avatar sx={{ bgcolor: '#ef6c00', color:'white', width: { xs: 22, md: 30 }, height: { xs: 22, md: 30 } }}><CategoryIcon sx={{ fontSize: { xs: 14, md: 18 } }} /></Avatar>
                                    <Typography variant="h6" fontWeight="bold" color="#e65100" sx={{ fontSize: { xs: '0.92rem', md: '1.12rem' } }}>Ürün bilgileri</Typography>
                                </Box>
                                <CardContent sx={{ flex: 1, py: { xs: 1.15, md: 1.85 }, px: { xs: 0.9, md: 1.35 }, '&:last-child': { pb: { xs: 1.15, md: 1.85 } } }}>
                                    <Stack sx={{ width: '100%', gap: { xs: 1.1, md: 2 } }}>
                                      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: { xs: 1.25, md: 1.75 }, alignItems: 'stretch' }}>
                                        <Box sx={{ flex: 1, minWidth: 0 }}>
                                          <DetailRow dense label="Kategori" value={selectedIslem.kategori} icon={<CategoryIcon/>} />
                                        </Box>
                                        <Box sx={{ flex: 1, minWidth: 0 }}>
                                          <DetailRow dense label="Ürün Adı" value={selectedIslem.urun} icon={<InfoIcon/>} />
                                        </Box>
                                      </Box>
                                      <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: { xs: 1.25, md: 1.75 }, alignItems: 'stretch' }}>
                                        <Box sx={{ flex: 1, minWidth: 0 }}>
                                          <DetailRow dense label="Miktar" value={`${formatAdetGram(selectedIslem).gram} Gr / ${formatAdetGram(selectedIslem).adet} Adet`} icon={<ScaleIcon/>} />
                                        </Box>
                                        <Box sx={{ flex: 1, minWidth: 0 }}>
                                          <DetailRow dense label="Barkod" value={selectedIslem.barkod} icon={<LocalOfferIcon/>} />
                                        </Box>
                                      </Box>
                                    </Stack>
                                    <Box sx={{mt: { xs: 0.65, md: 1 }, p: { xs: 0.85, md: 1.2 }, bgcolor:'#fff8e1', borderRadius: { xs: 1.1, md: 1.25 }, border:'1px dashed #ffc76a', minHeight: { xs: '68px', md: '88px' }, maxHeight: { xs: '96px', md: '120px' }, overflowY:'auto'}}>
                                        <Typography variant="caption" fontWeight="bold" color="#ff6f00" sx={{display:'block', mb: { xs: 0.45, md: 0.65 }, fontSize: { xs: '0.66rem', md: '0.74rem' }}}>İşlem açıklaması</Typography>
                                        <Typography variant="body1" sx={{fontSize: { xs: '0.78rem', md: '0.9rem' }, lineHeight: { xs: 1.4, md: 1.5 } }}>
                                            {selectedIslem.urunBilgisi || selectedIslem.islemAciklamasi || 'Ek açıklama girilmemiş.'}
                                        </Typography>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Box>
                        <Box sx={islemDetayKutuDisSx}>
                            <Card elevation={2} sx={{ width:'100%', borderRadius: 1.8, border:'1px solid #e2e8f0', display:'flex', flexDirection:'column', overflow:'hidden' }}>
                                <Box sx={{ py: { xs: 0.75, md: 1.2 }, px: { xs: 0.75, md: 1.35 }, display: 'flex', alignItems: 'center', gap: { xs: 0.75, md: 1.1 }, bgcolor: '#edf9f1', borderBottom: '1px solid #d3eed9' }}>
                                    <Avatar sx={{ bgcolor: '#2e7d32', color:'white', width: { xs: 22, md: 30 }, height: { xs: 22, md: 30 } }}><PaymentIcon sx={{ fontSize: { xs: 14, md: 18 } }} /></Avatar>
                                    <Typography variant="h6" fontWeight="bold" color="#1b5e20" sx={{ fontSize: { xs: '0.92rem', md: '1.12rem' } }}>Finansal detaylar</Typography>
                                </Box>
                                <CardContent sx={{ flex: 1, py: { xs: 1.15, md: 1.85 }, px: { xs: 0.9, md: 1.35 }, display:'flex', flexDirection:'column', '&:last-child': { pb: { xs: 1.15, md: 1.85 } } }}>
                                    <Grid container spacing={{ xs: 1, md: 2 }}>
                                        <Grid item xs={6}><DetailRow label="Has Fiyatı" value={formatCurrency(selectedIslem.hasFiyati)} /></Grid>
                                        <Grid item xs={6}><DetailRow label="Nakit Tahsilat" value={formatCurrency(selectedIslem.nakit)} /></Grid>
                                        <Grid item xs={6}><DetailRow label="Kredi Kartı" value={formatCurrency(selectedIslem.krediKarti)} /></Grid>
                                        <Grid item xs={6}><DetailRow label="Havale / EFT" value={formatCurrency(selectedIslem.havaleEft)} /></Grid>
                                        {selectedIslem.firma?.firmaIsmi && (
                                          <Grid item xs={12}>
                                            <DetailRow
                                              label="Has Eşdeğer (Gr)"
                                              value={`${(parseFloat(selectedIslem.hasEsdeger) || 0).toFixed(2)} gr`}
                                              icon={<ScaleIcon />}
                                              color="#0f4c81"
                                            />
                                          </Grid>
                                        )}
                                    </Grid>
                                    <Box sx={{ mt:'auto', pt: { xs: 1, md: 1.5 } }}>
                                        <Divider sx={{ mb: { xs: 1, md: 1.35 } }} />
                                        <Box sx={{ display:'flex', justifyContent:'space-between', alignItems:'center', mb: { xs: 1, md: 1.25 } }}>
                                            <Typography variant="body1" color="textSecondary" fontWeight="bold" sx={{ fontSize: { xs: '0.78rem', md: '0.9rem' } }}>İŞLEM TUTARI:</Typography>
                                            <Typography variant="h5" fontWeight="900" color="#1e293b" sx={{ fontSize: { xs: '1.42rem', md: '1.72rem' } }}>{formatCurrency(selectedIslem.toplamTutar)}</Typography>
                                        </Box>
                                        <Box sx={{ 
                                            display:'flex', justifyContent:'space-between', alignItems:'center', mb: { xs: 1, md: 1.25 }, 
                                            bgcolor: selectedIslem.bakiye > 0 ? '#ffebee' : '#f1f8e9', 
                                            p: { xs: 1, md: 1.35 }, borderRadius:1.4, border: selectedIslem.bakiye > 0 ? '1px solid #ef9a9a' : '1px solid #a5d6a7'
                                        }}>
                                            <Typography variant="body1" color={selectedIslem.bakiye > 0 ? 'error' : 'success'} fontWeight="bold" sx={{display:'flex', alignItems:'center', fontSize: { xs: '0.78rem', md: '0.9rem' }}}>
                                                <AccountBalanceWalletIcon sx={{mr: { xs: 0.45, md: 0.6 }, fontSize: { xs: 15, md: 18 }}}/>KALAN BAKİYE:
                                            </Typography>
                                            <Typography variant="h5" color={selectedIslem.bakiye > 0 ? 'error' : 'success'} fontWeight="900" sx={{ fontSize: { xs: '1.32rem', md: '1.58rem' } }}>
                                                {formatCurrency(selectedIslem.bakiye)}
                                            </Typography>
                                        </Box>
                                        <Box sx={{textAlign:'center'}}>
                                            {selectedIslem.teslimatDurumu === "Teslimat Bekliyor" ? (
                                                <Button 
                                                    variant="contained" 
                                                    color="warning" 
                                                    size="medium" 
                                                    fullWidth 
                                                    startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <LocalShippingIcon />}
                                                    onClick={handleTeslimatTamamla}
                                                    disabled={loading}
                                                    sx={{ py: { xs: 0.85, md: 1.05 }, fontWeight: 'bold', fontSize: { xs: '0.8rem', md: '0.92rem' }, bgcolor: '#ed6c02', '&:hover': { bgcolor: '#e65100' } }}
                                                >
                                                    {loading ? "İŞLENİYOR..." : "TESLİM ET VE STOKTAN DÜŞ"}
                                                </Button>
                                            ) : (
                                                <Chip label="✅ TESLİM EDİLDİ" color="success" sx={{fontWeight:'bold', fontSize: { xs: '0.78rem', md: '0.88rem' }, width:'100%', py: { xs: 1.15, md: 1.45 }, borderRadius: 1.4}} />
                                            )}
                                        </Box>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Box>
                        </Box>
                      </Grid>
                    )}
                </Grid>
            )}
        </DialogContent>
        <DialogActions sx={{ p: { xs: 1.15, md: 2 }, borderTop:'1px solid #e0e6ef', backgroundColor:'#eef2f7', justifyContent:'flex-end', flexWrap: 'wrap', gap: { xs: 0.55, md: 1 }, rowGap: { xs: 0.75, md: 1 }, '& .MuiButton-root': { fontSize: { xs: '0.78rem', md: '0.9rem' }, flex: { xs: '1 1 auto', md: 'none' }, minWidth: { xs: 'calc(50% - 4px)', md: 'auto' } } }}>
            {isEditing ? (
                <>
                    <Button onClick={() => setIsEditing(false)} color="inherit" variant="outlined" size="small" startIcon={<CloseIcon sx={{ fontSize: { xs: 14, md: 16 } }} />} sx={{ textTransform: 'none' }}>İptal</Button>
                    <Button onClick={handleEditSubmit} variant="contained" color="primary" size="small" startIcon={<SaveIcon sx={{ fontSize: { xs: 14, md: 16 } }} />} sx={{px:2.2, textTransform: 'none'}}>Kaydet</Button>
                </>
            ) : (
                <>
                    <Button onClick={handleDelete} color="error" variant="outlined" size="small" startIcon={<DeleteIcon sx={{ fontSize: { xs: 14, md: 16 } }} />} sx={{ textTransform: 'none' }}>Sil</Button>
                    <Button onClick={() => setIsEditing(true)} variant="contained" color="info" size="small" startIcon={<EditIcon sx={{ fontSize: { xs: 14, md: 16 } }} />} sx={{px:2, textTransform: 'none'}}>Düzenle</Button>
                    <Button onClick={handleCloseModal} variant="contained" color="inherit" size="small" sx={{px:2.2, bgcolor:'#2f4158', color:'white', textTransform: 'none', '&:hover':{bgcolor:'#243448'}}}>Kapat</Button>
                </>
            )}
        </DialogActions>
      </Dialog>
    </Box>
  );
}

export default TumIslemler;